import dynamic from 'next/dynamic';
import React from 'react';
import SectionLoader from '../../global/SectionLoader/SectionLoader';

export const DynamicComponentForOtherPreview = dynamic(
  () => import('../../contentPage/otherPreview/OtherPreview'),
  {
    ssr: false,
    loading: () => <SectionLoader height={[491, 901, 509]} />,
  },
);

export const DynamicComponentForWhatToRead = dynamic(
  () => import('../../whatToRead/WhatToRead'),
  {
    ssr: false,
    loading: () => <SectionLoader height={[1153, 1305, 985]} />,
  },
);
